export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            position: 'relative'
        }
    })
}
